// gameUtils.js
// Import provider icons
import splitIcon from "../images/split.svg";
import spribeIcon from "../images/spribe.svg";
import elbetIcon from "../images/elbet.svg";
import pragmeticIcon from "../images/pragmetic.svg";
import imoonIcon from "../images/imoon.svg";
import goldenIcon from "../images/golden.svg";
import aviatrixIcon from "../images/aviatrix.svg";
import evolutionIcon from "../images/evolution.svg";
import smartsoftIcon from "../images/smartsoft.svg";
import aviatorImg from "../images/aviator/aviator.png";
import aviatrixImg from "../images/aviatrix/aviatrix.jpeg";
import rocketmenImg from "../images/icons_mobule_new/redtiger/225-140/rocketmen.jpg";
import minesImg from "../images/icons_mobule_new/spribe/225-140/mines.jpg";
import diceImg from "../images/icons_mobule_new/spribe/225-140/dice.jpg";
import kenoImg from "../images/icons_mobule_new/spribe/225-140/keno.jpg";
import kayaIcon from "../images/kaya.svg";
import spinmaticIcon from "../images/spinmatic.svg";
import { APP_CONFIG, config, GameModes } from "../config";
import { API_URL, PROVIDERS_WITHOUT_DEMO } from "../constants";

// Provider configuration with icons and display names
export const PROVIDERS = {
  fazi: {
    id: "fazi",
    name: "Fazi",
    icon: splitIcon,
    folderName: "fazi",
  },
  aviatrix: {
    id: "aviatrix",
    name: "Aviatrix",
    icon: aviatrixIcon,
    folderName: "aviatrix",
  },
  aviator: {
    id: "aviator",
    name: "Aviator",
    icon: aviatrixIcon,
    folderName: "aviator",
  },
  pragmaticplay: {
    id: "pragmaticplay",
    name: "Pragmatic Play",
    icon: pragmeticIcon,
    folderName: "pragmaticplay",
  },
  netent: {
    id: "netent",
    name: "Netent",
    icon: splitIcon,
    folderName: "netent", // folder name in games directory
  },
  //   split: {
  //     id: "split",
  //     name: "Split The Pot",
  //     icon: splitIcon,
  //     folderName: "split", // folder name in games directory
  //   },
  spribe: {
    id: "spribe",
    name: "Spribe",
    icon: spribeIcon,
    folderName: "spribe",
  },
  relax: {
    id: "relax",
    name: "Relax",
    icon: elbetIcon,
    folderName: "relax",
  },
  // NOTE: KELT PRAGMATIC DISABLED
  // pragmatic: {
  //   id: "pragmatic",
  //   name: "Pragmatic Play",
  //   icon: pragmeticIcon,
  //   folderName: "pragmatic",
  // },
  spinomenal: {
    id: "spinomenal",
    name: "Spinomenal",
    icon: imoonIcon,
    folderName: "spinomenal",
  },
  redtiger: {
    id: "redtiger",
    name: "Redtiger",
    icon: goldenIcon,
    folderName: "redtiger",
  },
  //   aviatrix: {
  //     id: "aviatrix",
  //     name: "Aviatrix",
  //     icon: aviatrixIcon,
  //     folderName: "aviatrix",
  //   },
  playngo: {
    id: "playngo",
    name: "Playngo",
    icon: evolutionIcon,
    folderName: "playngo",
  },
  playson: {
    id: "playson",
    name: "Playson",
    icon: kayaIcon,
    folderName: "playson",
  },
  pushgaming: {
    id: "pushgaming",
    name: "Pushgaming",
    icon: spinmaticIcon,
    folderName: "pushgaming",
  },
  "3oaks": {
    id: "3oaks",
    name: "3oaks",
    icon: spinmaticIcon,
    folderName: "3oaks",
  },
  amatic: {
    id: "amatic",
    name: "Amatic",
    icon: spinmaticIcon,
    folderName: "amatic",
  },
  greentube: {
    id: "greentube",
    name: "Greentube",
    icon: spinmaticIcon,
    folderName: "greentube",
  },
  hacksaw: {
    id: "hacksaw",
    name: "Hacksaw",
    icon: spinmaticIcon,
    folderName: "hacksaw",
  },
  igrosoft: {
    id: "igrosoft",
    name: "Igrosoft",
    icon: spinmaticIcon,
    folderName: "igrosoft",
  },
};
/**
 * Imports game images specifically for Pragmatic Provider from API response
 * @param {Object} apiResponse - The API response containing game list
 * @param {string} dimension - Dimension for the images (default: "225-140")
 * @returns {Promise<{[key: string]: Object}>} Object with game aliases as keys and image info as values
 */
export const importPragmaticGameImages = async (dimension = "225-140") => {
  try {
    const apiResponse = await fetchPragmaticGames();
    // Check if the API response is valid
    if (
      apiResponse?.error !== "0" ||
      !apiResponse?.gameList ||
      !Array.isArray(apiResponse.gameList)
    ) {
      throw new Error("Invalid API response format");
    }

    // Create an object mapping game aliases to their image paths
    const gameImages = {};

    apiResponse.gameList.forEach((game) => {
      if (game.gameID && game.gameName && game.gameUrl) {
        // Use gameID as the alias
        const alias = game.gameID;

        gameImages[alias] = {
          imagePath: game.gameUrl, // Use the direct URL from the API
          provider: "pragmaticplay", // Main provider
          name: game.gameName, // Store the game name
          gameID: game.gameID, // Store the game ID
        };
      }
    });
    console.log("pragmatic", gameImages);
    return gameImages;
  } catch (error) {
    console.error(`Error importing Pragmatic game images:`, error);
    return {};
  }
};
/**
 * Imports game images specifically for Pragmatic Provider from API response
 * @param {Object} apiResponse - The API response containing game list
 * @param {string} dimension - Dimension for the images (default: "225-140")
 * @returns {Promise<{[key: string]: Object}>} Object with game aliases as keys and image info as values
 */
export const importLivePragmaticGameImages = async (dimension = "225-140") => {
  try {
    const apiResponse = await fetchLivePragmaticGames();
    // Check if the API response is valid
    if (!apiResponse || !Array.isArray(apiResponse)) {
      throw new Error("Invalid API response format");
    }

    // Create an object mapping game aliases to their image paths
    const gameImages = {};

    apiResponse.forEach((game) => {
      if (game.tableId && game.tableName && game.tableImage) {
        // Use gameID as the alias
        const alias = game.tableId;

        gameImages[alias] = {
          imagePath: game.tableImage,
          provider: "pragmaticlive",
          name: game.tableName,
          gameID: game.gameID,
          maxBet: game.maxBet,
          minBet: game.minBet,
          lastResults: game.lastResults,
          totalSeatedPlayers: game.totalSeatedPlayers,
        };
      }
    });
    // console.log("pragmatic", gameImages);
    return gameImages;
  } catch (error) {
    console.error(`Error importing Live Pragmatic game images:`, error);
    return {};
  }
};
/**
 * Imports game images specifically for Kelt provider which contains multiple sub-providers
 * @param {string} dimension - Dimension folder name (e.g., '225-140')
 * @returns {Promise<{[key: string]: string}>} Object with game aliases as keys and image paths as values
 */
export const importKeltGameImages = async (dimension = "225-140") => {
  try {
    const context = require.context(
      "../images/icons_mobule_new/",
      true, // Include subdirectories
      /\.(png|jpe?g|svg)$/ // Look for image files
    );

    // Get all matching file paths for the given dimension
    const gamePaths = context
      .keys()
      .filter((path) => path.includes(`/${dimension}/`));

    // Create an object mapping game aliases to their image paths
    const gameImages = {};
    gamePaths.forEach((path) => {
      // Extract game alias from the file path
      // Example path: ./subprovider/225-140/gamename.png -> gamename
      const pathParts = path.split("/");
      const alias = pathParts[pathParts.length - 1].replace(/\.[^/.]+$/, "");
      // Extract subprovider name
      const subProvider = pathParts[1]; // First directory after kelt

      gameImages[alias] = {
        imagePath: context(path), // Image path
        provider: "kelt", // Main provider
        subProvider: subProvider, // Sub-provider information
      };
    });

    return gameImages;
  } catch (error) {
    console.error(`Error importing Kelt game images:`, error);
    return {};
  }
};
// Hardcoded top games data
export const topGamesData = {
  aviator: {
    imagePath: aviatorImg,
    provider: "aviator",
    name: "aviator",
  },
  aviatrix: {
    imagePath: aviatrixImg,
    provider: "aviatrix",
    name: "aviatrix",
  },
  mines: {
    imagePath: minesImg,
    provider: "spribe",
    name: "mines",
  },
  keno: {
    imagePath: kenoImg,
    provider: "spribe",
    name: "keno",
  },
  // jetX: {
  //   imagePath: kayaImg,
  //   provider: "kaya",
  //   name: "Kaya",
  // },
  rocketmen: {
    imagePath: rocketmenImg,
    provider: "redtiger",
    name: "rocketmen",
  },
  dice: {
    imagePath: diceImg,
    provider: "spribe",
    name: "dice",
  },
  // crazyball: {
  //   imagePath: slotsImg,
  //   provider: "pragmaticplay",
  //   name: "Slots",
  // },
  // wheeloffortune: {
  //   imagePath: tableImg,
  //   provider: "pragmaticplay",
  //   name: "Table Games",
  // },
  // live: {
  //   imagePath: liveImg,
  //   provider: "pragmaticplay",
  //   name: "Live Casino",
  // }
};
/**
 * Dynamically imports game images based on provider and dimensions
 * @param {string} provider - Provider folder name (e.g., 'netent', 'pragmatic', 'kelt')
 * @param {string} dimension - Dimension folder name (e.g., '225-140')
 * @returns {Promise<{[key: string]: string}>} Object with game aliases as keys and image paths as values
 */
export const importGameImages = async (provider, dimension = "225-140") => {
  console.log("passed provider", provider);
  try {
    // Special handling for Kelt provider that has multiple sub-providers
    if (provider === "kelt") {
      return await importKeltGameImages(dimension);
    }
    // Special handling for Pragmatic provider that uses API data
    if (provider === "pragmaticplay") {
      return await importPragmaticGameImages(dimension);
    }
    // Standard handling for other providers
    // Using webpack's require.context to get all images in the specified provider/dimension folder
    const context = require.context(
      "../images/",
      true, // Include subdirectories
      /\.(png|jpe?g|svg)$/ // Look for image files
    );

    // Get all matching file paths
    const gamePaths = context
      .keys()
      .filter((path) => path.includes(`/${provider}/`));

    // Create an object mapping game aliases to their image paths
    const gameImages = {};
    gamePaths.forEach((path) => {
      // Extract game alias from the file path
      // Example path: ./netent/225-140/starburst.png -> starburst
      const alias = path
        .split("/")
        .pop()
        .replace(/\.[^/.]+$/, "");
      gameImages[alias] = {
        imagePath: context(path), // Image path
        provider: provider, // Associate the provider
      };
    });

    return gameImages;
  } catch (error) {
    console.error(`Error importing game images for ${provider}:`, error);
    return {};
  }
};
/**
 * Fetches game data from Pragmatic Provider API
 * @returns {Promise<Object>} The API response with game list
 */
export const fetchPragmaticGames = async () => {
  try {
    // Replace with your actual API endpoint
    const response = await fetch(
      `${APP_CONFIG.API_URL}/api/pragmaticgameiconurls`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Pragmatic games:", error);
    throw error;
  }
};
/**
 * Fetches game data from Pragmatic Provider API
 * @returns {Promise<Object>} The API response with Live game list
 */
export const fetchLivePragmaticGames = async () => {
  try {
    // Replace with your actual API endpoint
    const response = await fetch(`${APP_CONFIG.API_URL}/livecasino/thumbnails`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Live Pragmatic games:", error);
    throw error;
  }
};
/**
 * Gets available providers from the games directory
 * @returns {Promise<string[]>} Array of provider names
 */
export const getAvailableProviders = async () => {
  try {
    const context = require.context(
      "../images/icons_mobule_new",
      true,
      /\.(png|jpe?g|svg)$/
    );

    // Extract unique provider names from paths
    const providers = new Set(
      context
        .keys()
        .map((path) => path.split("/")[1])
        .filter(Boolean)
    );

    return Array.from(providers);
  } catch (error) {
    console.error("Error getting available providers:", error);
    return [];
  }
};

export const loadAllGameImages = async () => {
  try {
    // Get all available providers
    const providers = await getAvailableProviders();
    const allGames = {};

    // Load games for each provider
    for (const provider of providers) {
      // Special handling for Pragmatic provider
      if (provider === "pragmatic") {
        const pragmaticData = await fetchPragmaticGames();
        const pragmaticGames = await importGameImages(
          provider,
          "225-140",
          pragmaticData
        );
        Object.assign(allGames, pragmaticGames);
      } else {
        // Standard handling for other providers
        const games = await importGameImages(provider);
        Object.assign(allGames, games);
      }
    }

    return allGames;
  } catch (error) {
    console.error("Error loading all game images:", error);
    return {};
  }
};

/**
 * Gets available dimensions for a specific provider
 * @param {string} provider - Provider name
 * @returns {Promise<string[]>} Array of dimension options
 */
export const getAvailableDimensions = async (provider) => {
  try {
    const context = require.context(
      "../images/icons_mobule_new",
      true,
      /\.(png|jpe?g|svg)$/
    );

    // Extract unique dimensions from paths for the specified provider
    const dimensions = new Set(
      context
        .keys()
        .filter((path) => path.includes(`/${provider}/`))
        .map((path) => path.split("/")[2])
        .filter(Boolean)
    );

    return Array.from(dimensions);
  } catch (error) {
    console.error(`Error getting dimensions for ${provider}:`, error);
    return [];
  }
};
// Function to detect if user is on mobile
export const isMobileDevice = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

// Transform API data to match the React component structure
export const transformApiData = (apiData) => {
  // Handle case when apiData is an array or a single object
  const apiDataArray = Array.isArray(apiData) ? apiData : [apiData];

  return apiDataArray.map((leagueData) => {
    return {
      leagueTitle: leagueData.leagueName,
      titleWrps: [
        {
          matches: leagueData.events.map((event) => {
            // Parse event details
            const eventDetails = [
              { text: event.eventDate, bold: true },
              { text: `#${generateEventId(event.gameName)}`, bold: false },
              {
                text: `+${getAdditionalMarketsCount(
                  event.additionalMarkets
                )} more`,
                bold: false,
              },
            ];

            // Transform odds structure
            const transformedOdds = transformEventOdds(event);

            return {
              team1: getTeam1(event.gameName),
              team2: getTeam2(event.gameName),
              details: eventDetails,
              odds: transformedOdds,
              eventDate: event.eventDate,
              gameId: event.gameId,
            };
          }),
        },
      ],
    };
  });
};

// Helper function to extract team1 from event name (e.g., "Ukraine V Belgium" -> "Ukraine")
const getTeam1 = (gameName) => {
  return gameName.split(" V ")[0];
};

// Helper function to extract team2 from event name (e.g., "Ukraine V Belgium" -> "Belgium")
const getTeam2 = (gameName) => {
  return gameName.split(" V ")[1];
};

// Helper function to generate a pseudo event ID from game name
// In real implementation, you might want to use a more reliable ID from your API
const generateEventId = (gameName) => {
  return Math.abs(
    gameName.split("").reduce((a, b) => {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0)
  )
    .toString()
    .substring(0, 4);
};

// Helper function to count additional markets
const getAdditionalMarketsCount = (markets) => {
  return markets ? markets.length : 0;
};

// Transform event odds to match the required structure
const transformEventOdds = (event) => {
  const odds = [];

  // First row: 1-X-2 (Match Result)
  const matchResult = findMarket(event.additionalMarkets, "Match Result");
  if (matchResult) {
    odds.push(
      matchResult.marketOdds.map((odd) => ({
        label: odd.label,
        value: odd.value,
        colSpan: 4,
        highlight: false,
      }))
    );
  } else if (event.odds) {
    // Fallback to main odds if Match Result not in additional markets
    odds.push(
      event.odds.map((odd) => ({
        label: odd.label,
        value: odd.value,
        colSpan: 4,
        highlight: false,
      }))
    );
  }

  // Second row: Double Chance (1X-12-X2)
  const doubleChance = findMarket(event.additionalMarkets, "Double Chance");
  if (doubleChance) {
    odds.push(
      doubleChance.marketOdds.map((odd) => ({
        label: odd.label.toLowerCase(),
        value: odd.value,
        colSpan: 4,
        highlight: false,
      }))
    );
  }

  // Third row: Both Teams to Score (yes-no)
  const bothTeams = findMarket(event.additionalMarkets, "Both Teams to Score");
  if (bothTeams) {
    odds.push(
      bothTeams.marketOdds.map((odd) => ({
        label: odd.label.toLowerCase(),
        value: odd.value,
        colSpan: 6,
        highlight: false,
      }))
    );
  }

  return odds;
};

// Helper function to find a specific market by name
const findMarket = (markets, marketName) => {
  if (!markets) return null;
  return markets.find((market) => market.marketName === marketName);
};
export const formatAmount = (amount, currency = "USD", locale = "am-ET") => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};
export const detectMobileCarrier = (phoneNumber) => {
  // Remove the country code if present (assumes +254 or 254)
  const cleanedNumber = phoneNumber.replace(/^(\+?254)/, "");

  // Define prefix patterns
  const safaricomPrefixes = /^(?:70|71|72|74|75|76|79)\d{7}$/;
  const airtelPrefixes = /^(?:73|78|10[0-9])\d{7}$/;

  if (safaricomPrefixes.test(cleanedNumber)) {
    return "Safaricom";
  } else if (airtelPrefixes.test(cleanedNumber)) {
    return "Airtel";
  } else {
    return "Unknown";
  }
};
/**
 * Detects Kenyan mobile network provider (Safaricom or Airtel)
 * @param {string} phoneNumber - Phone number in format 2547XXXXXXXX or 07XXXXXXXX
 * @returns {string} - 'Safaricom', 'Airtel', or 'Unknown'
 */
export function detectNetworkProvider(phoneNumber) {
  // Clean the phone number (remove +, spaces, etc.)
  const cleaned = phoneNumber.toString().replace(/\D/g, "");

  // Convert to 254 format if it starts with 0
  const normalized = cleaned.startsWith("0")
    ? "254" + cleaned.substring(1)
    : cleaned;

  // Check if it's a valid Kenyan number
  if (!normalized.startsWith("254") || normalized.length !== 12) {
    return "Unknown";
  }

  // Extract the first 6 digits after 254 (the prefix)
  const prefix = normalized.substring(3, 6);

  // Safaricom prefixes (as of 2023)
  const safaricomPrefixes = [
    "701",
    "702",
    "703",
    "704",
    "705",
    "706",
    "707",
    "708",
    "709", // Old
    "710",
    "711",
    "712",
    "713",
    "714",
    "715",
    "716",
    "717",
    "718",
    "719",
    "720",
    "721",
    "722",
    "723",
    "724",
    "725",
    "726",
    "727",
    "728",
    "729",
    "790",
    "791",
    "792",
    "793",
    "794",
    "795",
    "796",
  ];

  // Airtel prefixes (as of 2023)
  const airtelPrefixes = [
    "730",
    "731",
    "732",
    "733",
    "734",
    "735",
    "736",
    "737",
    "738",
    "739",
    "750",
    "751",
    "752",
    "753",
    "754",
    "755",
    "756",
    "757",
    "758",
    "759",
    "770",
    "771",
    "772",
    "773",
    "774",
    "775",
    "776",
    "777",
    "778",
    "779",
    "780",
    "781",
    "782",
    "783",
    "784",
    "785",
    "786",
    "787",
    "788",
    "789",
  ];

  if (safaricomPrefixes.includes(prefix)) {
    return "Safaricom";
  } else if (airtelPrefixes.includes(prefix)) {
    return "Airtel";
  } else {
    return "Unknown";
  }
}
export function formatGameName(name) {
  if (!name) return "";

  // Split camelCase by inserting space before capital letters (e.g. superMarioBros -> super Mario Bros)
  const spaced = name.replace(/([a-z])([A-Z])/g, "$1 $2");

  // Convert to lowercase, then split into words
  return spaced
    .toLowerCase()
    .split(/[\s_]+/) // Split by space or underscore
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
export const allowsDemo = (provider) => {
  return !PROVIDERS_WITHOUT_DEMO.includes(provider?.toLowerCase());
};
//   // Example usage:
//   console.log(formatAmount(1234.5)); // $1,234.50 (Default: USD, en-US)
//   console.log(formatAmount(1234.5, "EUR", "de-DE")); // 1.234,50 € (Euro, German locale)
//   console.log(formatAmount(1234.5, "KES", "sw-KE")); // KSh1,234.50 (Kenyan Shilling)
